import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingcarrentalshirdi() {



    const cardData = {





keyword: "Wedding Car Rental Shirdi",

headingDescription: "Sai Shirdi Cab provides premium Wedding Car Rental in Shirdi for wedding functions, family celebrations, guest transportation, bridal and groom travel, reception events, and other special occasions. Customers can choose from comfortable Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles according to the number of guests and event requirements. The service can be arranged for wedding guest pickups, hotel-to-venue transfers, airport and railway station transfers, local event transportation, and outstation travel from Shirdi. Clean vehicles, experienced chauffeurs, comfortable seating, spacious luggage areas, flexible schedules, and coordinated pickup and drop arrangements help make wedding transportation easier to manage. Sai Shirdi Cab can also arrange multiple cars or larger vehicles for families and groups who need coordinated transportation throughout the wedding itinerary. Customers can plan customized travel according to venue locations, guest schedules, event timings, and the overall duration of the celebration.",

topPlaces: [
{
title: "Nashik",
description: "Nashik is a popular wedding and celebration destination from Shirdi, with hotels, banquet venues, resorts, and event spaces suitable for family functions. Wedding car rentals can be arranged for guests traveling between Shirdi and Nashik. Multiple vehicles can also be coordinated for families attending wedding ceremonies and receptions."
},
{
title: "Pune",
description: "Pune is a major wedding and event destination with numerous hotels, banquet halls, resorts, and celebration venues. Families traveling from Shirdi can hire wedding cars for comfortable guest transfers and event transportation. Sedan, Ertiga, Innova, and Innova Crysta options can be selected according to group size."
},
{
title: "Mumbai",
description: "Mumbai offers a wide range of premium hotels, banquet venues, resorts, and wedding destinations for large family celebrations. Guests traveling from Shirdi can arrange chauffeur-driven cars for direct transportation to their event venue or accommodation. Wedding transportation can be customized for airport pickups, hotel transfers, and multiple functions."
},
{
title: "Aurangabad",
description: "Aurangabad is a popular destination for weddings, family functions, and cultural celebrations in the region. Customers from Shirdi can arrange private wedding car rentals for guests traveling to hotels, banquet venues, and event locations. Comfortable vehicles provide convenient transportation throughout the celebration."
},
{
title: "Kolhapur",
description: "Kolhapur is an important Maharashtra destination for family functions, traditional weddings, and celebrations. Guests traveling from Shirdi can book private cars for long-distance wedding transportation. Spacious vehicles are suitable for families carrying luggage and traveling between hotels, venues, and other event locations."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a scenic destination popular for resort weddings, family celebrations, and destination events. Travelers from Shirdi can arrange comfortable chauffeur-driven cars for the journey and local venue transfers. Wedding car rental can be customized for multi-day celebrations and guest transportation."
},
{
title: "Lonavala",
description: "Lonavala is a popular destination for resort weddings and private family celebrations because of its scenic surroundings and event venues. Guests traveling from Shirdi can hire private cars for direct transportation to their resort or wedding venue. Round-trip and multi-day rental options provide flexibility for wedding schedules."
},
{
title: "Indore",
description: "Indore is a major wedding and commercial destination that can be reached from Shirdi by comfortable private cab. Families can arrange wedding transportation for guests, relatives, and event participants traveling between hotels and venues. Chauffeur-driven vehicles offer convenient long-distance travel with flexible pickup timings."
},
{
title: "Ujjain",
description: "Ujjain is an important religious destination and can be suitable for families planning wedding-related travel combined with pilgrimage visits. Guests traveling from Shirdi can arrange private wedding cars for comfortable transportation to hotels and event locations. The itinerary can be customized for family functions and religious visits."
},
{
title: "Goa",
description: "Goa is a popular destination wedding location known for beach resorts, hotels, and celebration venues. Families traveling from Shirdi can arrange comfortable private cars for long-distance transportation to Goa. Multi-day rental services can support airport transfers, hotel movements, wedding venue travel, and return journeys."
},
{
title: "Satara",
description: "Satara offers hotels, resorts, and event venues suitable for family celebrations and wedding functions. Guests traveling from Shirdi can book chauffeur-driven cars for comfortable transportation to the wedding destination. Flexible rental arrangements are useful when guests require transportation throughout multiple wedding events."
}
],













"services": [
{
"name": "Wedding Car Rental Shirdi",
"description": "Wedding Car Rental Shirdi provides private vehicle arrangements for couples, families, and guests attending wedding functions in and around Shirdi. Customers can select suitable cars according to event schedules, passenger requirements, luggage, preferred vehicle category, and transportation needs."
},
{
"name": "Wedding Car Rental in Shirdi",
"description": "Wedding Car Rental in Shirdi offers convenient transportation options for wedding ceremonies, receptions, family functions, and related events. Vehicle arrangements can be planned according to the function timing, pickup locations, guest requirements, and preferred car type."
},
{
"name": "Shirdi Wedding Car Rental",
"description": "Shirdi Wedding Car Rental provides private cars for wedding-related transportation requirements. Cars can be arranged for the bride, groom, family members, guests, venue transfers, hotel pickups, and other functions according to the planned event schedule."
},
{
"name": "Shirdi Wedding Car Hire",
"description": "Shirdi Wedding Car Hire offers flexible vehicle arrangements for couples and families attending marriage functions. Customers can choose a suitable car according to seating requirements, event timing, pickup and drop locations, travel distance, and preferred transportation plan."
},
{
"name": "Wedding Cars on Rent in Shirdi",
"description": "Wedding Cars on Rent in Shirdi provide convenient private transportation for wedding celebrations and associated events. Different vehicle categories can be arranged for couples, families, relatives, and guests according to the event itinerary and passenger requirements."
},
{
"name": "Wedding Car Booking Shirdi",
"description": "Wedding Car Booking Shirdi allows customers to reserve suitable vehicles in advance for marriage functions and ceremonies. Booking arrangements can include pickup details, event timings, passenger requirements, vehicle selection, venue transfers, and multiple wedding-related transportation needs."
},
{
"name": "Luxury Wedding Car Rental Shirdi",
"description": "Luxury Wedding Car Rental Shirdi provides premium vehicle options for couples and families looking for an elegant transportation arrangement during wedding celebrations. Vehicles can be scheduled for ceremonies, receptions, hotel transfers, venue arrivals, and other special occasions."
},
{
"name": "Wedding Sedan Car Rental Shirdi",
"description": "Wedding Sedan Car Rental Shirdi offers comfortable private sedans for couples, family members, and wedding guests. Sedan vehicles can be arranged for hotel pickups, venue transfers, ceremonies, receptions, and other event-related transportation requirements."
},
{
"name": "Wedding Innova Rental Shirdi",
"description": "Wedding Innova Rental Shirdi provides spacious transportation for families and small groups attending wedding functions. The Innova offers comfortable seating and luggage capacity and can be arranged for guest transfers, family travel, venue transportation, and event schedules."
},
{
"name": "Wedding Innova Crysta Rental Shirdi",
"description": "Wedding Innova Crysta Rental Shirdi offers a spacious and premium vehicle option for wedding transportation. The vehicle can be arranged for couples, families, VIP guests, hotel transfers, ceremony venues, reception locations, and other event-related travel requirements."
},
{
"name": "Wedding Ertiga Rental Shirdi",
"description": "Wedding Ertiga Rental Shirdi provides a practical vehicle option for families and small groups attending wedding events. The Ertiga can be arranged for hotel pickups, venue transfers, guest transportation, family travel, and other wedding functions according to the event itinerary."
},
{
"name": "Wedding Car with Driver in Shirdi",
"description": "Wedding Car with Driver in Shirdi provides convenient private transportation for couples, families, and guests during wedding functions. A suitable vehicle can be arranged with a driver according to event timing, pickup locations, venue transfers, and travel requirements."
},
{
"name": "Bridal Car Rental Shirdi",
"description": "Bridal Car Rental Shirdi provides private transportation arrangements for the bride during wedding ceremonies and related functions. The vehicle can be selected according to comfort preferences, event schedule, pickup location, venue requirements, and planned wedding transportation."
},
{
"name": "Groom Car Rental Shirdi",
"description": "Groom Car Rental Shirdi offers private vehicle arrangements for the groom and accompanying family members during wedding celebrations. Transportation can be organized according to the wedding schedule, pickup point, ceremony venue, passenger requirements, and preferred vehicle category."
},
{
"name": "Marriage Car Rental Shirdi",
"description": "Marriage Car Rental Shirdi provides private transportation options for wedding ceremonies, receptions, family functions, and related celebrations. Customers can arrange suitable vehicles for couples, relatives, guests, hotel transfers, venue travel, and other event requirements."
},
{
"name": "Wedding Transportation in Shirdi",
"description": "Wedding Transportation in Shirdi provides organized private travel solutions for couples, families, and guests attending marriage functions. Transportation can be planned for multiple pickup points, hotels, wedding venues, reception locations, ceremonies, and return transfers."
},
{
"name": "Wedding Taxi Service Shirdi",
"description": "Wedding Taxi Service Shirdi offers private taxi transportation for wedding guests and family members traveling between hotels, venues, and other locations. Taxi arrangements can be scheduled according to event timings, passenger count, vehicle category, and required pickup or drop points."
},
{
"name": "Wedding Cab Service Shirdi",
"description": "Wedding Cab Service Shirdi provides convenient cab transportation for couples, families, relatives, and guests attending wedding events. Suitable vehicles can be arranged according to passenger capacity, luggage requirements, function schedules, venue locations, and transportation plans."
},
{
"name": "Wedding Guest Transportation Shirdi",
"description": "Wedding Guest Transportation Shirdi provides private travel arrangements for guests attending marriage ceremonies and celebrations. Vehicles can be scheduled for railway station pickups, hotel transfers, wedding venue travel, reception transportation, and return journeys according to the guest itinerary."
},
{
"name": "Affordable Wedding Car Rental Shirdi",
"description": "Affordable Wedding Car Rental Shirdi provides practical vehicle options for customers looking to manage wedding transportation expenses. Car categories can be selected according to passenger count, event requirements, travel duration, pickup locations, venue transfers, and preferred rental arrangements."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides private cab, taxi, and car rental transportation for wedding events, family functions, local travel, pilgrimage journeys, airport transfers, and outstation trips in and around Shirdi. Suitable sedan, Ertiga, Innova, Innova Crysta, and other vehicle options can be arranged."
}
],
"tableData": [
["Wedding Car Rental Shirdi", "Wedding Car Rental in Shirdi"],
["Shirdi Wedding Car Rental", "Shirdi Wedding Car Hire"],
["Wedding Cars on Rent in Shirdi", "Wedding Car Booking Shirdi"],
["Luxury Wedding Car Rental Shirdi", "Wedding Sedan Car Rental Shirdi"],
["Wedding Innova Rental Shirdi", "Wedding Innova Crysta Rental Shirdi"],
["Wedding Ertiga Rental Shirdi", "Wedding Car with Driver in Shirdi"],
["Bridal Car Rental Shirdi", "Groom Car Rental Shirdi"],
["Marriage Car Rental Shirdi", "Wedding Transportation in Shirdi"],
["Wedding Taxi Service Shirdi", "Wedding Cab Service Shirdi"],
["Wedding Guest Transportation Shirdi", "Affordable Wedding Car Rental Shirdi"],
["Sai Shirdi Cabs", "Wedding Car Rental Shirdi"]
]
,












    whychoose: [
        { 
            WhyChooseheading: "Wedding Car Rental in Shirdi for Special Occasions", 
            WhyChoosedescription: "Sai Shirdi Cabs provides wedding car rental services in Shirdi for wedding functions, family celebrations, guest transportation, engagement ceremonies, receptions, and other special occasions. Choose suitable vehicles for bride and groom travel, family members, relatives, and wedding guests." 
        }, 
        { 
            WhyChooseheading: "Cars for Bride & Groom Transportation", 
            WhyChoosedescription: "Arrange a comfortable private car for the bride and groom according to the wedding schedule. Pickup and drop arrangements can be coordinated between hotels, residences, wedding venues, temples, banquet halls, and other required locations in and around Shirdi." 
        }, 
        { 
            WhyChooseheading: "Wedding Guest Transportation Service", 
            WhyChoosedescription: "Provide convenient transportation for wedding guests travelling between hotels, event venues, railway stations, airports, and other locations. Multiple vehicles can be considered when guests arrive at different times or require transportation throughout the function." 
        }, 
        { 
            WhyChooseheading: "Wide Range of Vehicles for Wedding Travel", 
            WhyChoosedescription: "Choose from Sedan Cars, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and larger vehicles depending on the number of passengers, luggage requirements, wedding schedule, and type of transportation required." 
        }, 
        { 
            WhyChooseheading: "Suitable for Family Functions & Ceremonies", 
            WhyChoosedescription: "Wedding car rentals can be arranged for engagement ceremonies, wedding functions, receptions, family gatherings, temple visits, hotel transfers, and other events where comfortable and coordinated transportation is required." 
        }, 
        { 
            WhyChooseheading: "Flexible Local & Outstation Wedding Travel", 
            WhyChoosedescription: "Arrange vehicles for local transportation within Shirdi or discuss outstation travel requirements for wedding guests coming from nearby cities. Travel plans can be organized according to the function schedule and required pickup and drop locations." 
        }, 
        { 
            WhyChooseheading: "Dedicated Vehicles for Multiple Transfers", 
            WhyChoosedescription: "Families can arrange dedicated vehicles for repeated transfers between hotels, wedding venues, railway stations, airports, and other destinations during the event. Vehicle selection can be adjusted according to the number of guests and travel requirements." 
        }, 
        { 
            WhyChooseheading: "Book Wedding Car Rental Shirdi with Sai Shirdi Cabs", 
            WhyChoosedescription: "Share your wedding date, pickup locations, venue details, passenger count, number of vehicles required, travel schedule, and preferred car type with Sai Shirdi Cabs to plan suitable wedding transportation." 
        } 
    ] 

}; 

const faqData = [ 
    { 
        question: "Can I book a Wedding Car Rental in Shirdi?", 
        answer: "Yes, Sai Shirdi Cabs provides wedding car rental services in Shirdi for bride and groom transportation, family functions, receptions, guest transfers, and other wedding-related travel requirements." 
    }, 
    { 
        question: "Can I book a car for the bride and groom?", 
        answer: "Yes, a private car can be arranged for bride and groom transportation between their hotel, residence, wedding venue, temple, reception location, or other required destinations." 
    }, 
    { 
        question: "Do you provide transportation for wedding guests?", 
        answer: "Yes, wedding guest transportation can be arranged between hotels, wedding venues, railway stations, airports, and other locations according to the event schedule." 
    }, 
    { 
        question: "Which vehicles are available for wedding car rental in Shirdi?", 
        answer: "Vehicle options may include Sedan Cars, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and larger vehicles depending on passenger count and wedding transportation requirements." 
    }, 
    { 
        question: "Can I book multiple cars for a wedding function?", 
        answer: "Yes, multiple vehicles can be arranged for weddings when transportation is required for different family members, guests, venues, hotels, or separate travel schedules." 
    }, 
    { 
        question: "Can wedding cars be used for hotel and venue transfers?", 
        answer: "Yes, wedding rental vehicles can be used for transfers between hotels, residences, wedding venues, reception halls, temples, railway stations, airports, and other planned locations." 
    }, 
    { 
        question: "Can I book a car for an outstation wedding?", 
        answer: "Yes, outstation wedding transportation can be discussed for guests and families travelling from Shirdi to another city or destination according to their wedding itinerary." 
    }, 
    { 
        question: "Can I book a Tempo Traveller or Mini Bus for wedding guests?", 
        answer: "Yes, Tempo Travellers, Mini Buses, and larger vehicles can be considered for group transportation depending on the number of wedding guests and luggage requirements." 
    }, 
    { 
        question: "Can I arrange wedding transportation for multiple days?", 
        answer: "Yes, multi-day vehicle arrangements can be discussed for weddings requiring transportation across several functions, ceremonies, hotel transfers, sightseeing, and venue movements." 
    }, 
    { 
        question: "How can I book Wedding Car Rental Shirdi with Sai Shirdi Cabs?", 
        answer: "Share your wedding date, pickup points, venue details, passenger count, number of vehicles, travel schedule, and preferred vehicle types with Sai Shirdi Cabs to proceed with the wedding car rental arrangement." 
    } 
]; 

const testimonials = [ 
    { 
        id: 1, 
        name: "Mr. Rohan Patil", 
        feedback: "We arranged wedding transportation in Shirdi for our family and guests. The private vehicles helped us manage hotel and venue transfers conveniently and made the travel arrangements easier during the functions.", 
        rating: 5 
    }, 
    { 
        id: 2, 
        name: "Mrs. Neha Deshmukh", 
        feedback: "Our wedding required transportation for relatives travelling between the hotel and venue. We arranged multiple vehicles so everyone could travel comfortably according to the event schedule.", 
        rating: 5 
    } 
];


    

    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Car Rental Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/wedding-car-rental-shirdi.webp",
  "description":
    "Book Wedding Car Rental Shirdi with Sai Shirdi Cabs for stylish, comfortable, and reliable wedding transportation. We provide wedding cars on rent in Shirdi for bride and groom transfers, family transportation, guest pickup and drop, wedding venue transfers, reception travel, and special wedding events. Choose from Sedan, Ertiga, Innova, Innova Crysta, and other comfortable vehicles with professional drivers, well-maintained cars, flexible rental options, timely service, and convenient booking for weddings and related functions.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/wedding-car-rental-shirdi"
  }
};





    return (
        <div>

<Helmet>
  <title>Wedding Car Rental Shirdi | Wedding Car Hire in Shirdi | +91 7776814559</title>

  <meta
    name="description"
    content="Book Wedding Car Rental Shirdi with Sai Shirdi Cabs for comfortable and reliable wedding transportation. Hire Sedan, Ertiga, Innova and Innova Crysta for bride and groom travel, wedding guest pickup and drop, venue transfers, reception transportation and special events with professional drivers and flexible rental options."
  />

  <meta
    name="keywords"
    content="Wedding Car Rental Shirdi, wedding car rental in Shirdi, Shirdi wedding car rental, Shirdi wedding car hire, wedding cars on rent in Shirdi, wedding car booking Shirdi, Shirdi wedding car booking, wedding taxi rental Shirdi, wedding cab rental Shirdi, wedding taxi in Shirdi, wedding cab in Shirdi, wedding transportation Shirdi, wedding transport service Shirdi, Shirdi wedding transportation service, Shirdi wedding transport service, wedding car hire in Shirdi, wedding car on rent in Shirdi, marriage car rental Shirdi, marriage car hire Shirdi, marriage cars on rent in Shirdi, Shirdi marriage car rental, Shirdi marriage car hire, wedding vehicle rental Shirdi, wedding vehicle hire Shirdi, wedding car booking in Shirdi, online wedding car booking Shirdi, wedding cab booking Shirdi, wedding taxi booking Shirdi, wedding car rental service Shirdi, wedding car hire service Shirdi, best wedding car rental Shirdi, affordable wedding car rental Shirdi, luxury wedding car rental Shirdi, premium wedding car rental Shirdi, wedding sedan rental Shirdi, wedding Sedan car hire Shirdi, wedding Ertiga rental Shirdi, wedding Ertiga hire Shirdi, wedding Innova rental Shirdi, wedding Innova hire Shirdi, wedding Innova Crysta rental Shirdi, wedding Innova Crysta hire Shirdi, wedding Tempo Traveller Shirdi, wedding Tempo Traveller rental Shirdi, wedding guest transportation Shirdi, wedding guest cab service Shirdi, wedding guest taxi Shirdi, wedding guest pickup Shirdi, wedding guest drop Shirdi, wedding venue transportation Shirdi, wedding venue transfer Shirdi, Shirdi wedding venue cab, Shirdi wedding venue taxi, bride groom car rental Shirdi, bride and groom car Shirdi, bride car rental Shirdi, groom car rental Shirdi, bride groom wedding taxi Shirdi, wedding pickup and drop Shirdi, wedding function car rental Shirdi, wedding event car rental Shirdi, reception car rental Shirdi, reception taxi Shirdi, wedding ceremony cab Shirdi, wedding ceremony taxi Shirdi, marriage function cab Shirdi, marriage function taxi Shirdi, wedding family car rental Shirdi, wedding family cab Shirdi, wedding group taxi Shirdi, wedding group cab Shirdi, wedding outstation car rental Shirdi, wedding outstation taxi Shirdi, wedding car rental with driver Shirdi, wedding car hire with driver Shirdi, wedding taxi with driver Shirdi, wedding cab with driver Shirdi, wedding car rental for one day Shirdi, one day wedding car rental Shirdi, wedding car rental for events Shirdi, wedding transportation package Shirdi, wedding cab package Shirdi, wedding taxi package Shirdi, Shirdi wedding travel service, Shirdi wedding transport booking, Shirdi wedding cab booking online, Shirdi wedding taxi booking online, wedding car rental near Shirdi, wedding car hire near Shirdi, wedding transportation near Shirdi, Sai Shirdi Cabs"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/61.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Weddingcarrentalshirdi;